// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 538 ? "recorder" : chunkId) + "-legacy." + {"515":"9c6ce420","538":"d3555b05","554":"5f559ecc"}[chunkId] + ".js";
};